const DefaultMediaDisplayOption = Object.freeze({
  COLLAPSE_ALL_MEDIA: 'COLLAPSE_ALL_MEDIA',
  EXPAND_ALL_MEDIA: 'EXPAND_ALL_MEDIA'
})
export default DefaultMediaDisplayOption
export type DefaultMediaDisplayOptionStrings = typeof DefaultMediaDisplayOption[keyof typeof DefaultMediaDisplayOption]
// RESERVE BELOW
